import { render, staticRenderFns } from "./vanOnkyOffice.vue?vue&type=template&id=c55e273e&"
import script from "./vanOnkyOffice.vue?vue&type=script&lang=js&"
export * from "./vanOnkyOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports